import { Pipe, PipeTransform } from '@angular/core';
import { dateHelper } from '../helpers/date-helper';

@Pipe({
  standalone: false,
  name: 'stringifyMinutes'
})
export class StringifyMinutesPipe implements PipeTransform {
  transform(minutes: number, format: string): string {
    return dateHelper.stringifyMinutesCount(minutes, format);
  }
}
